import Marquee from '@/modules/Marquee/Marquee.js';
import Search from './Search.js';

const initSearchPersonsSlider = (rootElement) => {
  const elements = Array.from(rootElement.querySelectorAll('[data-component="marquee"]'));

  elements.forEach((element) => {
    new Marquee(element);
  });
};

const initSearchPersons = () => {
  const elements = Array.from(document.querySelectorAll('[data-component="search-persons"]'));

  elements.forEach((element) => {
    new Search(element);
    initSearchPersonsSlider(element);
  });
};

export default initSearchPersons;
